import * as Types from '../../../../graphql-types'

import { gql } from '@apollo/client'
import { ContentDetails_Tag_ContentReferenceFragmentFragmentDoc } from '../../../../services/yi/queries/ContentDetailsTagContentReferenceFragment.generated'
export type GaiaVideo_ContentFragmentFragment = {
  __typename?: 'Content'
  episodeNumber?: number | null
  seasonNumber?: number | null
  director?: string | null
  producer?: string | null
  writer?: string | null
  studio?: string | null
  copyright?: string | null
  instructor?: string | null
  cast?: string | null
  productType?: string | null
  displayType?: string | null
  seoTitle?: string | null
  seoDescription?: string | null
  seoKeywords?: string | null
  seoRobotsNoFollow?: boolean | null
  seoRobotsNoIndex?: boolean | null
  excludeFromRecommendations?: boolean | null
  contentSearchNoIndex?: boolean | null
  adminCategory?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  category?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  centers?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  contentOrigin?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  consciousFormat?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  consciousTopic?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  filmSubject?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  filmType?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  fitnessDuration?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  fitnessLevel?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  fitnessInstructor?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  fitnessSpecialty?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  fitnessStyle?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  genres?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  interviewGuest?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  interviewHost?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  marketingCenters?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  meditationFocus?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  meditationStyle?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  meditationTeacher?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  meditationDuration?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  onboardingChoices?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  product?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  rainbowCategory?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  recipeDiet?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  recipeType?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  series?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  similarVideos?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  thirdPartyGenre?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  videoCollection?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  videoTopic?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  yogaDuration?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  yogaFocus?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  yogaLevel?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  yogaStyle?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  yogaTeacher?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
}

export const GaiaVideo_ContentFragmentFragmentDoc = gql`
  fragment GaiaVideo_ContentFragment on Content {
    episodeNumber
    seasonNumber
    director
    producer
    writer
    studio
    copyright
    instructor
    cast
    productType
    displayType
    seoTitle
    seoDescription
    seoKeywords
    seoRobotsNoFollow
    seoRobotsNoIndex
    excludeFromRecommendations
    contentSearchNoIndex
    adminCategory: contentReferencesFrom(types: "admin_category") {
      ...ContentDetails_Tag_ContentReferenceFragment
    }
    category: contentReferencesFrom(types: "category") {
      ...ContentDetails_Tag_ContentReferenceFragment
    }
    centers: contentReferencesFrom(types: "centers") {
      ...ContentDetails_Tag_ContentReferenceFragment
    }
    contentOrigin: contentReferencesFrom(types: "content_origin") {
      ...ContentDetails_Tag_ContentReferenceFragment
    }
    consciousFormat: contentReferencesFrom(types: "conscious-format") {
      ...ContentDetails_Tag_ContentReferenceFragment
    }
    consciousTopic: contentReferencesFrom(types: "conscious-topic") {
      ...ContentDetails_Tag_ContentReferenceFragment
    }
    filmSubject: contentReferencesFrom(types: "film-subject") {
      ...ContentDetails_Tag_ContentReferenceFragment
    }
    filmType: contentReferencesFrom(types: "film-type") {
      ...ContentDetails_Tag_ContentReferenceFragment
    }
    fitnessDuration: contentReferencesFrom(types: "fitness-duration") {
      ...ContentDetails_Tag_ContentReferenceFragment
    }
    fitnessLevel: contentReferencesFrom(types: "fitness-level") {
      ...ContentDetails_Tag_ContentReferenceFragment
    }
    fitnessInstructor: contentReferencesFrom(types: "fitness-instructor") {
      ...ContentDetails_Tag_ContentReferenceFragment
    }
    fitnessSpecialty: contentReferencesFrom(types: "fitness-specialty") {
      ...ContentDetails_Tag_ContentReferenceFragment
    }
    fitnessStyle: contentReferencesFrom(types: "fitness-style") {
      ...ContentDetails_Tag_ContentReferenceFragment
    }
    genres: contentReferencesFrom(types: "genres") {
      ...ContentDetails_Tag_ContentReferenceFragment
    }
    interviewGuest: contentReferencesFrom(types: "interview-guest") {
      ...ContentDetails_Tag_ContentReferenceFragment
    }
    interviewHost: contentReferencesFrom(types: "interview-host") {
      ...ContentDetails_Tag_ContentReferenceFragment
    }
    marketingCenters: contentReferencesFrom(types: "marketing-centers") {
      ...ContentDetails_Tag_ContentReferenceFragment
    }
    meditationFocus: contentReferencesFrom(types: "fitness-style") {
      ...ContentDetails_Tag_ContentReferenceFragment
    }
    meditationStyle: contentReferencesFrom(types: "meditation-style") {
      ...ContentDetails_Tag_ContentReferenceFragment
    }
    meditationTeacher: contentReferencesFrom(types: "meditation-teacher") {
      ...ContentDetails_Tag_ContentReferenceFragment
    }
    meditationDuration: contentReferencesFrom(types: "meditation-duration") {
      ...ContentDetails_Tag_ContentReferenceFragment
    }
    onboardingChoices: contentReferencesFrom(types: "onboarding_choices") {
      ...ContentDetails_Tag_ContentReferenceFragment
    }
    product: contentReferencesFrom(types: "product") {
      ...ContentDetails_Tag_ContentReferenceFragment
    }
    rainbowCategory: contentReferencesFrom(types: "rainbow-category") {
      ...ContentDetails_Tag_ContentReferenceFragment
    }
    recipeDiet: contentReferencesFrom(types: "recipe-diet") {
      ...ContentDetails_Tag_ContentReferenceFragment
    }
    recipeType: contentReferencesFrom(types: "recipe-type") {
      ...ContentDetails_Tag_ContentReferenceFragment
    }
    series: contentReferencesFrom(types: "series") {
      ...ContentDetails_Tag_ContentReferenceFragment
    }
    similarVideos: contentReferencesFrom(types: "similar-videos") {
      ...ContentDetails_Tag_ContentReferenceFragment
    }
    thirdPartyGenre: contentReferencesFrom(types: "third-party-genre") {
      ...ContentDetails_Tag_ContentReferenceFragment
    }
    videoCollection: contentReferencesFrom(types: "video-collection") {
      ...ContentDetails_Tag_ContentReferenceFragment
    }
    videoTopic: contentReferencesFrom(types: "video-topic") {
      ...ContentDetails_Tag_ContentReferenceFragment
    }
    yogaDuration: contentReferencesFrom(types: "yoga-duration") {
      ...ContentDetails_Tag_ContentReferenceFragment
    }
    yogaFocus: contentReferencesFrom(types: "yoga-focus") {
      ...ContentDetails_Tag_ContentReferenceFragment
    }
    yogaLevel: contentReferencesFrom(types: "yoga-level") {
      ...ContentDetails_Tag_ContentReferenceFragment
    }
    yogaStyle: contentReferencesFrom(types: "yoga-style") {
      ...ContentDetails_Tag_ContentReferenceFragment
    }
    yogaTeacher: contentReferencesFrom(types: "yoga-teacher") {
      ...ContentDetails_Tag_ContentReferenceFragment
    }
  }
  ${ContentDetails_Tag_ContentReferenceFragmentFragmentDoc}
`
